import Search from "@mui/icons-material/Search";
import { IconButton, InputAdornment } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { type Dispatch, type FC, type SetStateAction, useCallback } from "react";
import { SystemValidationTextField } from "../../UIToolkit/Inputs/SystemValidationTextField";

export const StaffCommunicationNurseSearch: FC<{
	value: string;
	setValue: Dispatch<SetStateAction<string>>;
}> = ({ value, setValue }) => {
	const clearSearch = useCallback(() => {
		setValue("");
	}, [setValue]);

	return (
		<SystemValidationTextField
			label={"Search Nurse"}
			placeholder={"Start typing to search for a nurse..."}
			inputProps={{
				endAdornment: (
					<InputAdornment position={"end"}>
						{value && (
							<IconButton onClick={clearSearch}>
								<ClearIcon style={{ fontSize: "20px" }} />
							</IconButton>
						)}
						<Search style={{ fontSize: "20px" }} />
					</InputAdornment>
				),
			}}
			reserveHeightForHelperText={false}
			value={value}
			onChange={(e) => {
				setValue(e.target.value);
			}}
		/>
	);
};
